import { render, staticRenderFns } from "./caracteristics.vue?vue&type=template&id=1d8d6e2c&scoped=true"
import script from "./caracteristics.vue?vue&type=script&lang=js"
export * from "./caracteristics.vue?vue&type=script&lang=js"
import style0 from "./caracteristics.vue?vue&type=style&index=0&id=1d8d6e2c&prod&scoped=true&lang=less"
import style1 from "./caracteristics.vue?vue&type=style&index=1&id=1d8d6e2c&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8d6e2c",
  null
  
)

export default component.exports